module.exports = __webpack_public_path__ + "img/pills.9a70be37.svg";